module.exports = __webpack_public_path__ + "static/media/new-user.58000405.svg";